import React from "react";
import Button from "../components/Button";
import IMG1 from "../assets/img/img1.png";
import IMG2 from "../assets/img/img2.png";
import IMG3 from "../assets/img/img3.png";

export default function Hero() {
  return (
    <>
      <div className="pt-5 row align-items-center pb-3">
        <div className="col-md-8">
          <h1>Interior Design</h1>
          <p>
            Step into a world where the art of Interior Design is meticulously
            crafted to bring together timeless elegance and cutting-edge modern
            Innovation, Allowing you to transform your living spaces into the
            epitome of luxury and sophistication
          </p>
          <Button
            to="https://wa.me/917022851682/"
            title="Start Project"
            className="btn primary"
          />
        </div>
        <div className="col-md-4">
          <img src={IMG1} alt="" className="w-100" />
        </div>
      </div>
      <div className="row counter align-items-center">
        <div className="col-md-6">
          <div className="justify-content-between counter-items pb-4">
            <div style={{ background: "#e1cfc12b" }}>
              <div>
                <h2>18+</h2>
                <h5>Residential and Commercial projects completed</h5>
              </div>
              <div>
                <h2>18000sqft</h2>
                <h5>Designed for Diverse Clients</h5>
              </div>
              <div>
                <h2>2700+</h2>
                <h5>Unique Designs</h5>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <img src={IMG2} alt="" className="w-100" />

          {/* <img src={IMG3} alt="" className="w-100" /> */}
        </div>
      </div>
    </>
  );
}
